const dayFormat = new Intl.DateTimeFormat(undefined, {day: 'numeric', month: 'short', year: 'numeric'});
const timeFormat = new Intl.DateTimeFormat(undefined, {hour: 'numeric', minute: '2-digit'});

export const formatDate = (iso: string | null | undefined): string => (iso ? dayFormat.format(new Date(iso)) : '');

export const formatDateTime = (iso: string | null | undefined): string =>
    iso ? `${dayFormat.format(new Date(iso))}, ${timeFormat.format(new Date(iso))}` : '';

/** "today", "yesterday", "3 days ago", "2 weeks ago", then the date. */
export function relativeDay(iso: string | null | undefined, now: Date = new Date()): string {
    if (!iso) return '';
    const then = new Date(iso);
    const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
    const days = Math.round((startOfDay(now) - startOfDay(then)) / 86_400_000);
    if (days <= 0) return 'today';
    if (days === 1) return 'yesterday';
    if (days < 14) return `${days} days ago`;
    if (days < 60) return `${Math.round(days / 7)} weeks ago`;
    return dayFormat.format(then);
}
